import React, { Component } from "react";
import PropTypes from "prop-types";

import { Header, Table } from "semantic-ui-react";
import moment from 'moment';

class Vehicle extends Component {
  constructor(props) {
    super(props);
    this.state = { hidden: true };
    this.onClick = this.onClick.bind(this);
  }
  onClick(e) {
    e.preventDefault();
    this.setState({
      hidden: !this.state.hidden
    });
  }
  render() {
    const { vehicle } = this.props;
    const { hidden } = this.state;

    const stars = vehicle.vin.length > 4 ? "*".repeat(vehicle.vin.length - 4) : "";
    const last4 = vehicle.vin.length > 4 ? vehicle.vin.substring(vehicle.vin.length - 4) : "";
    return (
      <div id={`vehicle-${vehicle.vehicleNum}`}>
        <div className="field vehicle">
          <div>
            <Header id={`vehicleDisplayName-${vehicle.vehicleNum}`} as="h2" className="vehicle">
              {vehicle.displayName}
            </Header>{" "}
            
            (<a id={`vehicleDetailsBtn-${vehicle.vehicleNum}`} href="/#" onClick={this.onClick}>
              details
            </a>)
          </div>
          <div>
            {vehicle.vin ? (
              <Header id={`vehicleVin-${vehicle.vehicleNum}`} as="h3">
                VIN:{" "}
                { stars + last4 }
              </Header>
            ) : null}
                </div>
                <div>
                    {vehicle.deleteFutureEffectiveDate ? (
                        <Header id={`vehicleEffectiveDate-${vehicle.vehicleNum}`} as="h2">
                            <b>  This vehicle is scheduled to delete on: {moment(vehicle.deleteFutureEffectiveDate).format('L')} </b>
                        </Header>
                    ) : null}
                </div>
                <br/>
        </div>
        {!hidden ? (
          <div id={`vehicleCoverages-${vehicle.vehicleNum}`} className="coverages">
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    Coverage Level
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {vehicle.coverages.filter(c => c.coverageLimitDescription !== "N/A").map((c, i) => (
                    <Table.Row id={`vehicleCoverage-${vehicle.vehicleNum}-${i}`} key={i}>
                      <Table.Cell id={`vehicleCoverageDescription-${vehicle.vehicleNum}-${i}`}>{c.description}</Table.Cell>
                      <Table.Cell id={`vehicleCoverageLimitDescription-${vehicle.vehicleNum}-${i}`}>{c.coverageLimitDescription}</Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </div>
        ) : null}
      </div>
    );
  }
}

Vehicle.propTypes = {
  vehicle: PropTypes.object.isRequired
};

export default Vehicle;
